import { Component, inject, input, model } from '@angular/core';

import { SellingCompanyReport } from '../../../models';
import { LanguageService } from '../../../services';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrl: './report-header.component.scss',
})
export class ReportHeaderComponent {
  protected readonly languageService = inject(LanguageService);

  public readonly header = input<string>();
  public readonly model = model<SellingCompanyReport>();

  readonly telLabel = this.languageService.translate($localize`Telephone`, 'Tel');
  readonly webLabel = this.languageService.translate($localize`Website`, 'Web');
}
